import React from 'react';

import { useElements, useStripe } from '@stripe/react-stripe-js';

import { Block, withBlockRendering } from '../common/Block.jsx';
import { Wrapper as ButtonWrapper, withBlockTypeConfigPropsV2 } from '../common/Button.jsx';
import FormField from '../common/FormField.jsx';
import { default as InventoryHelper } from '../common/Inventory.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import Token from '../common/Token.jsx';
import Utilities from '../common/Utilities.jsx';

import { Builder, EmptyPlaceholder } from '../layout/Builder.jsx';
import Defaults from '../layout/Defaults.jsx';

import { InventoryLineItemCellContainer, PromoCodeLineItemCellContainer } from './CartLineItemCell.jsx';
import { withStripeElements } from './StripeElements.jsx';

const Mode = {
    checkout: 'checkout',
    emptyCart: 'empty_cart',
    purchaseConfirmation: 'purchase_confirmation'
}
let _CartControllerInst;
function _CartController(props) {
    React.useEffect(() => {
        _CartControllerInst = true;
        return () => _CartControllerInst = undefined
    }, []);

    const stripe = useStripe();
    const elements = useElements();

    const getQuery = () => {
        if (!window || !window.location || !window.location.search) {
            return null;
        }
        return Utilities.parseQueryString(window.location.search.substring(1));
    }
    const updateQuery = (newEditions) => {
        if (!window) {
            return;
        }
        if (window.history && window.history.replaceState) {
            // TODO do we want to do this?
            window.history.replaceState({}, document.title, cart.formatUrl(newEditions, props.querySub));
        } else if (window.location) {
            window.location.href = cart.formatUrl(newEditions, props.querySub);
        }
    }

    // Editions
    const [editionIdString, setEditionIdString] = React.useState(undefined);
    const [editions, setEditions] = React.useState([]);
    React.useEffect(() => {
        let _editions = [];
        if (props.builder) {
            if (props.data && props.data.editionId) {
                _editions.push({ EditionId: props.data.editionId, IsFramed: false, Quantity: 1 });
            }
        } else {
            const query = getQuery();
            if (query) {
                if (query.products) {
                    // Meta store link ingestion
                    const products = query.products.split(',');
                    products.forEach(p => {
                        const components = p.split(':');
                        if (components.length) {
                            let quantity = 1;
                            if (components.length > 1) {
                                const parsed = parseInt(components[1], 10);
                                if (!isNaN(parsed)) {
                                    quantity = parsed;
                                }
                            }
                            _editions.push({ EditionId: components[0], IsFramed: false, Quantity: quantity });
                        }
                    });
                } else if (query.editionId) {
                    if (Array.isArray(query.editionId)) {
                        const framed = query.framed || [];
                        _editions = query.editionId.map((EditionId, i) => ({ EditionId, IsFramed: framed[i] || false }));
                    } else {
                        _editions.push({ EditionId: query.editionId, IsFramed: query.framed || false });
                    }
                }
            }
            if (window && window.location && window.location.pathname) {
                const segments = window.location.pathname.split('/');
                const lastSegment = segments.pop() || segments.pop();
                const parsed = parseInt(lastSegment, 10);
                if (!isNaN(parsed)) {
                    _editions.push({ EditionId: parsed, IsFramed: false, Quantity: 1 });
                }
            }
            let localEditions = cart.getItemsFromStorage();
            if (localEditions && !Array.isArray(localEditions)) {
                localEditions = Object.keys(localEditions).map(d => ({ EditionId: d, IsFramed: false, Quantity: 1 }))
            }
            const newEditions = [];
            _editions.forEach(d => {
                let found = false;
                for (let i = 0; i < localEditions.length; i++) {
                    if (localEditions[i].EditionId != d.EditionId) {
                        continue;
                    }
                    found = true;
                    newEditions.push(localEditions[i]);
                    break;
                }
                if (!found) {
                    newEditions.push({ EditionId: d.EditionId, IsFramed: d.Framed || false, Quantity: d.Quantity || 1 });
                }
            })
            cart.setItems(newEditions, props.querySub);
            _editions = [...newEditions];

            if (_editions.length == 0) {
                const promoCodeId = cart && cart.getPromoCodeFromStorage();
                if (promoCodeId) {
                    setCartData({ promoCode: { promoCodeId } });
                } else {
                    setCartData({});
                }
                return;
            }
        }
        setEditions(_editions);
    }, []);
    const handleEditionRemove = (editionId) => {
        const _editions = [];
        const localEditions = cart.getItemsFromStorage();
        localEditions.forEach(d => {
            if (editionId !== d.EditionId) {
                _editions.push(d);
            }
        })
        cart.setItems(_editions, props.querySub);
        setEditions(_editions);
        getCart({ requestEditions: _editions });
        updateQuery(_editions);
    }
    const handleLineItemQuantityBlur = (editionId) => {
        let _cartData = cartData;
        let edition;
        for (let i = 0; i < _cartData.lineItems.length; i++) {
            edition = InventoryHelper.edition(_cartData.lineItems[i].inventory);
            if (!edition || edition.editionId != editionId) {
                continue;
            }
            if (_cartData.lineItems[i].quantity) {
                // Refresh cart with updated quantity
                getCart({ requestEditions: editions });
                return;
            }

            // Quantity was empty on blur => Reset to what's in local storage
            const localEditions = cart.getItemsFromStorage();
            for (let i = 0; i < localEditions.length; i++) {
                if (localEditions[i].EditionId != editionId) {
                    continue;
                }
                _cartData.lineItems[i].quantity = localEditions[i].Quantity;
                setCartData({ ..._cartData });
                break;
            }
            break;
        }
    }
    const handleLineItemQuantityChange = (editionId, quantity) => {
        let _cartData = cartData;
        let edition;
        for (let i = 0; i < _cartData.lineItems.length; i++) {
            edition = InventoryHelper.edition(_cartData.lineItems[i].inventory);
            if (!edition || edition.editionId != editionId) {
                continue;
            }
            _cartData.lineItems[i].quantity = quantity;
            setCartData({ ..._cartData });
            break;
        }
        if (!quantity) {
            return;
        }
        const localEditions = cart.getItemsFromStorage();
        for (let i = 0; i < localEditions.length; i++) {
            if (localEditions[i].EditionId != editionId) {
                continue;
            }
            localEditions[i].Quantity = quantity;
            cart.setItems(localEditions, props.querySub);
            setEditions(localEditions);
            break;
        }
    }
    const isEmpty = editions.length == 0;

    // Cart
    const [cartData, setCartData] = React.useState(undefined);
    const getCart = ({ requestEditions, promoCodeId }, callback) => {
        let _promoCodeId = promoCodeId;
        if (!_promoCodeId && cartData && cartData.promoCode) {
            _promoCodeId = cartData.promoCode.promoCodeId;
        }
        const requestData = { Sub: props.config.subdomain };
        if (_promoCodeId) {
            requestData.PromoCodeId = _promoCodeId;
        }
        requestData.Editions = requestEditions || editions;
        let route = '/api/carts';
        if (props.handlerUrl) {
            route = props.handlerUrl + route;
        }
        $.post(
            route,
            requestData,
            (responseData) => {
                const updatedEditions = [];
                for (var i = 0; i < responseData.lineItems.length; i++) {
                    const item = responseData.lineItems[i];
                    if (!item || !item.inventory) {
                        continue;
                    }
                    updatedEditions.push({ EditionId: item.inventory.editions[0].editionId, IsFramed: item.isFramed, Quantity: item.quantity });
                }
                if (!_CartControllerInst) {
                    return;
                }
                if (props.builder && responseData.hasActivePromoCodes) {
                    responseData.promoCode = props.data && props.data.promoCode;
                }
                setCartData(responseData);
                setEditions(updatedEditions);

                if (!props.builder) {
                    cart.setItems(updatedEditions, props.querySub);
                }
                if (callback) {
                    callback(responseData);
                }
                if (props.onStripeInitialize) {
                    props.onStripeInitialize(responseData);
                }
            });
    }
    React.useEffect(() => {
        if (editions.length == 0 || cartData && cartData.lineItems) {
            return;
        }
        const idString = editions.map(d => d.EditionId).join('-');
        if (idString == editionIdString) {
            return;
        }
        setEditionIdString(idString);

        let promoCodeId;
        if (!cartData && !props.builder) {
            promoCodeId = cart && cart.getPromoCodeFromStorage();
        }
        getCart({ requestEditions: editions, promoCodeId });
    }), [editions];

    // Promo Code
    const handlePromoCodeRemove = () => {
        if (!cartData || !cartData.promoCode) {
            return;
        }
        if (!props.builder) {
            cart.setPromoCode(undefined);
        }
        cartData.promoCode = undefined;
        getCart({});

        // Force the UI to update
        const _cartData = { ...cartData };
        setCartData(_cartData);
    }

    // Billing
    const [billingInfo, setBillingInfo] = React.useState({ data: {} });
    const handleBillingInfoChange = (data) => {
        setBillingInfo({ data, formState: billingInfo.formState });
    }
    const handleError = (error, callback) => {
        setBillingInfo({ data: billingInfo.data, error, formState: 'error' });

        if (callback) {
            callback(false);
        }
    }
    const refSubmit = React.useRef(undefined);
    const validateBillingInfo = () => {
        if (!refSubmit || !refSubmit.current) {
            return false;
        }
        if (refSubmit.current.checkValidity()) {
            return true;
        }
        const temp = document.createElement('button')
        refSubmit.current.appendChild(temp)
        temp.click()
        refSubmit.current.removeChild(temp)
        return false;
    }
    // React.useEffect(() => {
    //     if (!billingInfo.paymentToken) {
    //         return;
    //     }
    //     // Apple Pay (billing info set inside payment request handler)
    //     if (validateBillingInfo()) {
    //         getCart({ requestEditions: editions }, (updatedCart) => submitPaymentToken(billingInfo.paymentToken, updatedCart, billingInfo.paymentTokenCallback))
    //     } else {
    //         setBillingInfo({ data: billingInfo.data, formState: 'form' });
    //     }
    // }, [billingInfo]);

    const handlePurchase = (_, e) => {
        if (e) {
            e.preventDefault();
        }
        if (!validateBillingInfo()) {
            return;
        }
        if (!stripe || !elements) {
            handleError('Could not find Stripe library. Please ensure you have disabled any browser plug-ins and try again.');
            return;
        }
        setBillingInfo({ data: billingInfo.data, formState: 'processing' });
        getCart({ requestEditions: editions }, async (updatedCart) => {
            if (updatedCart.hasError) {
                setBillingInfo({ data: billingInfo.data });
                return;
            }
            const { error: submitError } = await elements.submit()
            if (submitError) {
                handleError(submitError.message);
                return;
            }
            let name = [];
            if (billingInfo.data.FirstName) {
                name.push(billingInfo.data.FirstName);
            }
            if (billingInfo.data.LastName) {
                name.push(billingInfo.data.LastName);
            }
            const params = {
                shipping: {
                    name: name.join(' '),
                    address: {
                        line1: billingInfo.data.AddressLineOne,
                        line2: billingInfo.data.AddressLineTwo,
                        city: billingInfo.data.City,
                        state: billingInfo.data.State,
                        country: billingInfo.data.Country,
                        postal_code: billingInfo.data.Zip
                    }
                }
            }
            const { error: confirmationError, confirmationToken } = await stripe.createConfirmationToken({ elements, params });
            if (confirmationError) {
                handleError(confirmationError.message);
                return;
            }
            submitPaymentToken(confirmationToken.id, updatedCart);
        });
    }
    const finalizePayment = (postData, updatedCart, callback) => {
        $.post(
            '/api/buy',
            postData,
            (response) => {
                if (!response) {
                    return;
                }
                handlePaymentSuccess(updatedCart, callback);
            }).fail(jqXHR => {
                handleError(jqXHR && jqXHR.responseText ? jqXHR.responseText : 'An error has occurred. Please wait a moment and try again.', callback);
            });
    }
    const handlePaymentSuccess = (updatedCart, callback) => {
        cart.setItems([], props.querySub);
        cart.setPromoCode(undefined);
        updateQuery([]);
        setBillingInfo({ data: {}, formState: 'success' });
        if (window) {
            window.scrollTo(0, 0);
        }
        const totals = updatedCart.totals || {};
        if (window && window.ga) {
            try {
                const transactionId = Utilities.uuidv4();
                ga('require', 'ecommerce');
                ga('ecommerce:addTransaction', {
                    id: transactionId,                                  // Transaction ID. Required.
                    affiliation: 'ArtCloud',                            // Affiliation or store name.
                    revenue: totals.subtotal && totals.subtotal.value,  // Grand Total.
                    shipping: totals.shipping && totals.shipping.value, // Shipping.
                    tax: totals.tax && totals.tax.value                 // Tax.
                });
                let item, inventory;
                for (let i = 0; i < updatedCart.lineItems.length; i++) {
                    item = updatedCart.lineItems[i];
                    inventory = item.inventory || {};
                    ga('ecommerce:addItem', {
                        id: transactionId,                           // Transaction ID. Required.
                        category: null,                              // Category or variation.
                        name: inventory.title,                       // Product name. Required.
                        price: item.subtotal && item.subtotal.value, // Unit price.
                        quantity: item.quantity,                     // Quantity.
                        sku: inventory.sku || inventory.inventoryId  // SKU/code.
                    });
                }
                ga('ecommerce:send');
            } catch (e) { }
        }

        if (window && window.gtag) {
            try {
                const items = updatedCart.lineItems.map((d, i) => {
                    const inventory = d.inventory || {};
                    return {
                        id: inventory.sku || inventory.inventoryId,
                        list_position: i + 1,
                        name: inventory.title,
                        price: d.subtotal && d.subtotal.value,
                        quantity: d.quantity,
                        variant: inventory.medium
                    }
                })
                const transactionId = Utilities.uuidv4();
                gtag('event', 'purchase', {
                    transaction_id: transactionId,
                    affiliation: 'ArtCloud',
                    currency: 'USD',
                    items: items,
                    tax: totals.tax && totals.tax.value,
                    shipping: totals.shipping && totals.shipping.value,
                    value: totals.subtotal && totals.subtotal.value
                });
            } catch (e) { }
        }

        try {
            const items = updatedCart.lineItems.map(d => {
                const inventory = d.inventory || {};
                return {
                    category: null,
                    name: inventory.title,
                    price: d.subtotal && d.subtotal.value,
                    quantity: d.quantity,
                    sku: inventory.sku || inventory.inventoryId
                }
            })
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'purchase',
                transactionId: Utilities.uuidv4(),
                transactionAffiliation: 'ArtCloud',
                transactionProducts: items,
                transactionShipping: totals.shipping && totals.shipping.value,
                transactionTax: totals.tax && totals.tax.value,
                transactionTotal: totals.subtotal && totals.subtotal.value
            });
        } catch (e) { }

        if (window && window.fbq) {
            try {
                const contents = updatedCart.lineItems.map((d, i) => {
                    const inventory = d.inventory || {};
                    return {
                        id: inventory.sku || inventory.inventoryId,
                        quantity: d.quantity
                    }
                })
                fbq('track', 'Purchase', {
                    value: totals.subtotal && totals.subtotal.value,
                    currency: 'USD',
                    num_items: updatedCart.lineItems.length,
                    contents: contents
                });
            } catch (e) { }
        }
        if (window && window.pintrk) {
            try {
                const lineItems = updatedCart.lineItems.map((d, i) => {
                    const inventory = d.inventory || {};
                    return {
                        product_name: inventory.title,
                        product_id: inventory.editions && inventory.editions.length > 0 && inventory.editions[0].editionId,
                        product_price: d.subtotal && d.subtotal.value,
                        product_quantity: d.quantity
                    };
                })
                pintrk('track', 'checkout', {
                    value: totals.subtotal && totals.subtotal.value,
                    currency: 'USD',
                    order_id: Utilities.uuidv4(),
                    property: 'ArtCloud',
                    line_items: lineItems
                });
            } catch (e) { }
        }

        if (callback) {
            callback(true);
        }
        const query = getQuery();
        if (!query || !query.redirectUrl) {
            return;
        }
        alert(`Thank your for your purchase! You are being redirected to ${query.redirectUrl}.`);
        window.location.href = query.redirectUrl;
    }
    const submitPaymentToken = (token, updatedCart, callback) => {
        if (updatedCart.hasError) {
            setBillingInfo({ data: billingInfo.data });
            return;
        }
        const postData = {
            AddressLineOne: billingInfo.data.AddressLineOne,
            AddressLineTwo: billingInfo.data.AddressLineTwo,
            City: billingInfo.data.City,
            Country: billingInfo.data.Country,
            Email: billingInfo.data.Email,
            FirstName: billingInfo.data.FirstName,
            LastName: billingInfo.data.LastName,
            LineItems: editions,
            Notes: billingInfo.data.Notes,
            Phone: billingInfo.data.Phone,
            PromoCodeId: updatedCart.promoCode && updatedCart.promoCode.promoCodeId,
            State: billingInfo.data.State,
            Sub: props.config.subdomain,
            Token: token,
            Zip: billingInfo.data.Zip
        };
        if (window && window.cookie) {
            postData.Referrer = cookie.getCookie(cookie._referrer);
            postData.Utm = cookie.getCookie(cookie._utm);
        }
        if (!billingInfo.data[FormField[Name.Block.Cart.CardForm.Container].SameAddressCheckbox]) {
            postData.BillingAddressLineOne = billingInfo.data.BillingAddressLineOne;
            postData.BillingAddressLineTwo = billingInfo.data.BillingAddressLineTwo;
            postData.BillingCity = billingInfo.data.BillingCity;
            postData.BillingCountry = billingInfo.data.BillingCountry;
            postData.BillingState = billingInfo.data.BillingState;
            postData.BillingZip = billingInfo.data.BillingZip;
        }
        $.post(
            '/api/buy',
            postData,
            async (response) => {
                if (!response) {
                    return;
                }
                if (response.status == 'requires_action') {
                    const { error, paymentIntent, setupIntent } = await stripe.handleNextAction({ clientSecret: response.clientSecret })
                    if (error) {
                        handleError(error.message, callback);
                    } else if ((paymentIntent && paymentIntent.next_action) || (setupIntent && setupIntent.next_action)) {
                        // Artcloud.api.del(Artcloud.url.vendor.marketplace.invoices.paymentIntents.del(publicId, paymentIntent.id));
                        handleError(<span>Could not process the payment using the selected method.<br />Please choose another to proceed.</span>, callback);
                    } else if (paymentIntent || setupIntent) {
                        finalizePayment({ StripeIntentId: (paymentIntent || setupIntent).id, ...postData, Token: undefined }, updatedCart, callback);
                    } else {
                        handleError(<span>Could not process the payment using the selected method.<br />Please choose another to proceed.</span>, callback);
                    }
                    return;
                }
                handlePaymentSuccess(updatedCart, callback);
            }
        ).fail(jqXHR => {
            handleError(jqXHR && jqXHR.responseText ? jqXHR.responseText : 'An error has occurred. Please wait a moment and try again.', callback);
        });
    }
    
    // Block Rendering
    const currentState = (props) => {
        if (!props.data || !props.data.config) {
            return;
        }
        if (editions.length > 0 && billingInfo.formState != 'success' && props.data.config[Mode.checkout]) {
            return Mode.checkout;
        } else if (editions.length == 0 && billingInfo.formState != 'success' && props.data.config[Mode.emptyCart]) {
            return Mode.emptyCart;
        } else if (billingInfo.formState == 'success' && props.data.config[Mode.purchaseConfirmation]) {
            return Mode.purchaseConfirmation;
        }
    }
    const state = currentState(props);
    const data = props.data || {};
    let backgroundColor = props.backgroundColor;
    let blocks, pageProps;
    if (cartData && data.config) {
        const mode = props.builder ? props.mode : state;
        if (mode && data.config[mode]) {
            blocks = data.config[mode].blocks;
        }
        if (props.onPageProps) {
            pageProps = props.onPageProps();
        } else {
            pageProps = data.config[mode] && data.config[mode].page;
        }
        backgroundColor = pageProps && pageProps.config && pageProps.config.block && pageProps.config.block.backgroundColor || backgroundColor;
    }
    React.useEffect(() => {
        if (props.builder) {
            return;
        }
        const state = currentState(props);
        if (!state) {
            return;
        }
        document.body.style.backgroundColor = props.data.config[state].page.config.block.backgroundColor || '';
    }, [isEmpty, billingInfo.formState]);
    if (!blocks) {
        return null;
    }
    const disabled = billingInfo.formState == 'processing' || billingInfo.formState == 'success';
    let content = props.onBlockRendering(
        PageType.Cart,
        blocks,
        (d) => {
            if (!d.type) {
                return;
            }
            switch (d.type.value) {
                case Name.Block.Cart.ApplePayButton:
                    return { hidden: !props.builder }
                case Name.Block.Cart.CardForm.Container:
                case Name.Block.Cart.CardFormV1:
                    return { ...billingInfo, cartData, config: props.config, disabled, refSubmit, onChange: handleBillingInfoChange, onStripeElementsConfig: props.onStripeElementsConfig };
                case Name.Block.Cart.LineItem.List:
                    return { cartData, disabled, onEditionRemove: handleEditionRemove, onLineItemQuantityBlur: handleLineItemQuantityBlur, onLineItemQuantityChange: handleLineItemQuantityChange, onPromoCodeRemove: handlePromoCodeRemove }
                case Name.Block.Cart.PromoCode.Container:
                case Name.Block.Cart.PromoCodeV1:
                    return { disabled, hasActivePromoCodes: cartData.hasActivePromoCodes, onRefreshCart: getCart };
                case Name.Block.Cart.PurchaseButtonV1:
                case Name.Block.Cart.PurchaseButtonV2:
                    return { disabled, formState: billingInfo.formState, onButtonClick: handlePurchase }
                case Name.Block.Inventory.RecentlyViewed.List:
                    return { backgroundColor };
                default:
                    return { cartData };
            }
        },
        Builder.handleBlockProps
    )
    const style = props.style || {}
    if (pageProps) {
        Block.mapStyleConfigProps(style, pageProps.config.layout);
    }
    let className = 'cont--whitelabel';
    if (!props.builder) {
        if (billingInfo.formState == 'processing') {
            style.cursor = 'progress';
        }
        let error;
        if (cartData.hasError && cartData.error) {
            const errorStyles = Block.mapLayoutStyleConfigPropsWithPageKit({ paddingBottom: '20px' }, props);
            error = (
                <div className="error" style={errorStyles.containerStyle}>
                    <div style={errorStyles.style}>
                        {cartData.error}
                    </div>
                </div>
            )
        }
        content = (
            <>
                {error}
                {content}
            </>
        )
    } else {
        className += ' builder';
    }
    return (
        <div className={className} style={style}>
            {content}
        </div>
    )
}
const Controller = withStripeElements(withBlockRendering(_CartController));

// #region APPLE PAY BUTTON

function _ApplePayButtonComponent(props) {
    if (!props.builder) {
        return null;
    }
    const style = {}
    Utilities.copyObject(props.style, style);
    if (props.builder || props.disabled) {
        style.pointerEvents = 'none';
    }
    let buttonStyle = 'black';
    if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.style) {
        buttonStyle = props.blockConfig.layout.style;
    }
    let className = `apple-pay-button apple-pay-button-${buttonStyle}`;
    if (style.width) {
        className += ' apple-pay-button-fw';
    }
    return (
        <ButtonWrapper containerStyle={props.containerStyle}>
            <div className="btn--custom2 apple-pay-button-container" style={style}>
                <div className={className} onClick={props.onButtonClick} />
            </div>
        </ButtonWrapper>
    )
}
const ApplePayButtonComponent = withBlockTypeConfigPropsV2(_ApplePayButtonComponent, ['style']);
const ApplePayButton = { Component: ApplePayButtonComponent };

// #endregion APPLE PAY BUTTON

// #region LINE ITEMS

function LineItemsComponent(props) {
    const data = props.cartData || {};
    const inventory = [];
    let lineSpacing = '20px';
    let promoCodeContentConfig;
    if (data.lineItems) {
        let inventoryContentConfig;
        if (props.blockConfig && props.blockConfig.block) {
            if (props.blockConfig.block.lineSpacing && props.blockConfig.block.lineSpacing.value && props.blockConfig.block.lineSpacing.unit) {
                lineSpacing = `${props.blockConfig.block.lineSpacing.value}${props.blockConfig.block.lineSpacing.unit}`;
            }
            if (props.blockConfig.block.inventoryLineItemCell && props.blockConfig.block.inventoryLineItemCell.desktop && props.blockConfig.block.inventoryLineItemCell.desktop.blocks && props.blockConfig.block.inventoryLineItemCell.desktop.blocks.length > 0) {
                inventoryContentConfig = props.blockConfig.block.inventoryLineItemCell;
            }
            if (props.blockConfig.block.promoCodeLineItemCell && props.blockConfig.block.promoCodeLineItemCell.desktop && props.blockConfig.block.promoCodeLineItemCell.desktop.blocks && props.blockConfig.block.promoCodeLineItemCell.desktop.blocks.length > 0) {
                promoCodeContentConfig = props.blockConfig.block.promoCodeLineItemCell;
            }
        }
        if (!inventoryContentConfig) {
            inventoryContentConfig = Defaults.Block[Name.Block.Cart.LineItem.List].Cell.InventoryDesign(props.config);
        }
        data.lineItems.forEach(function (d, i) {
            if (!d.inventory || !d.inventory.editions || d.inventory.editions.length == 0) {
                return;
            }
            const edition = d.inventory.editions[0] || {};
            if (d.subtotal) {
                edition.price = d.subtotal.display;
            }
            let style;
            if (i != data.lineItems.length - 1) {
                style = { marginBottom: lineSpacing };
            }
            inventory.push(
                <div key={edition.editionId} style={style}>
                    <InventoryLineItemCellContainer
                        {...props}
                        contentConfig={inventoryContentConfig}
                        data={d}
                        id={edition.editionId}
                        onQuantityChange={props.onLineItemQuantityChange}
                        onQuantityInputBlur={props.onLineItemQuantityBlur}
                        onRemove={props.onEditionRemove} />
                </div>
            );
        });
    }
    if (!promoCodeContentConfig) {
        promoCodeContentConfig = Defaults.Block[Name.Block.Cart.LineItem.List].Cell.PromoCodeDesign(props.config);
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({ width: '100%' }, props);
    if (props.disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    let content = (
        <div className="cont--kit__content" style={layoutStyles.style}>
            {inventory}
            {
                data.promoCode &&
                data.promoCode.promoCodeId &&
                <div style={{ marginTop: lineSpacing }}>
                    <PromoCodeLineItemCellContainer
                        {...props}
                        contentConfig={promoCodeContentConfig}
                        data={data.promoCode}
                        onRemove={props.onPromoCodeRemove} />
                </div>
            }
        </div>
    );
    const containerStyle = layoutStyles.containerStyle || {};
    if (props.inLayout) {
        containerStyle.width = '100%';
    }
    if (layoutStyles.containerStyle) {
        content = <div className="cont--kit__wrapper" style={containerStyle}>{content}</div>
    }
    return content;
}
const LineItems = { Component: LineItemsComponent };

// #endregion LINE ITEMS

// #region TOTAL

function TotalComponent(props) {
    let label, labelStyle, totalStyle;
    if (props.blockConfig) {
        if (props.blockConfig.label) {
            labelStyle = {};
            Block.mapStyleConfigProps(labelStyle, props.blockConfig.label, (propName, propValue) => {
                switch (propName) {
                    case 'design':
                        label = propValue;
                        return true;
                }
            });
        }
        if (props.blockConfig.total) {
            totalStyle = {};
            Block.mapStyleConfigProps(totalStyle, props.blockConfig.total, (propName) => {
                switch (propName) {
                    case 'design':
                        return true;
                }
            });
        }
    }
    const parseContent = (props, tokenizedString) => {
        if (!tokenizedString) {
            return '';
        }
        const data = props.cartData || {};
        const design = Token.parseTokenizedString(tokenizedString, (keyword, options) => {
            let replaceString = '';
            switch (keyword) {
                case Token.Cart.EstimatedShipping:
                    if (data.totals && data.totals.shipping && data.totals.shipping.display && data.totals.shipping.display.length > 0 && data.totals.shipping.value > 0) {
                        replaceString = Token.getReplacementString(data.totals.shipping.display, options);
                    }
                    break;
                case Token.Cart.EstimatedTax:
                    if (data.totals && data.totals.tax && data.totals.tax.display && data.totals.tax.display.length > 0 && data.totals.tax.value > 0) {
                        replaceString = Token.getReplacementString(data.totals.tax.display, options);
                    }
                    break;
                case Token.Cart.Subtotal:
                    if (data.totals && data.totals.subtotal && data.totals.subtotal.display && data.totals.subtotal.display.length > 0) {
                        replaceString = Token.getReplacementString(data.totals.subtotal.display, options);
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            return replaceString;
        });
        if (Utilities.isHTMLContentEmpty(design)) {
            return '';
        }
        return design;
    }
    const [total, setTotal] = React.useState(undefined);
    React.useEffect(() => {
        setTotal(parseContent(props, props.blockConfig.total.design));
    }, [props.blockConfig.total.design, props.cartData.totals.shipping.value, props.cartData.totals.subtotal.value, props.cartData.totals.tax.value]);

    if (!props.builder && !total) {
        return null;
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({ alignItems: 'center', display: 'flex' }, props);
    let content = (
        <div className="cont--kit__content" style={layoutStyles.style}>
            {
                label &&
                <div className="cont--token" style={labelStyle} dangerouslySetInnerHTML={{ __html: label }} />
            }
            <div className="cont--token" style={totalStyle} dangerouslySetInnerHTML={{ __html: total }} />
            {
                !label &&
                !total &&
                <EmptyPlaceholder />
            }
        </div>
    );
    if (layoutStyles.containerStyle) {
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}
const TotalTokens = () => {
    return [
        { display: 'Subtotal', token: Token.Cart.Subtotal },
        { display: 'Estimated Shipping', token: Token.Cart.EstimatedShipping },
        { display: 'Estimated Tax', token: Token.Cart.EstimatedTax }
    ];
}
const Total = { Component: TotalComponent, Tokens: TotalTokens };

// #endregion TOTAL

export {
    ApplePayButton,
    Controller,
    LineItems,
    Mode,
    Total
};